export default __webpack_public_path__ + "static/media/Page_1.dd8d124c.jpg";